export default __webpack_public_path__ + "static/media/empty_cart.fcab541f.svg";